import Vue from 'vue'
import request from '@/helpers/request'

export default {
  GET_USER_SOURCE: ({ commit, state }, params) => {
    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.userSources.all}`,
      {
        params: params,
      },
      true,
    )
      .then(response => {
        const data = response.data.data
        commit('setUserSources', data)
      })
      .catch(err => {
        Vue.$notify({
          group: 'hasBottomNavigation',
          title: 'Не загрузились источники информации',
          type: 'error',
          text: err,
        })
      })
  },
}
